import { makeAutoObservable } from 'mobx'

import { type Debt } from '../types'
import { loadDebts, type DebtChartData } from '../utils/DebtUtils'
import { DebtPriority } from '../constants/Debts'

import { GlobalStore } from './GlobalStore'

export class DebtsStore {
  globalStore: GlobalStore
  uiStore: UiStore

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore
    this.uiStore = new UiStore()
    makeAutoObservable(this)
  }

  get debts(): Debt[] {
    const { visibleDebtAccounts: debtAccounts } = this.globalStore.accountStore
    const { selectedAccountGuids } = this.globalStore.globalUiStore
    const { debtGoals } = this.globalStore.goalStore

    const filteredDebtAccounts = selectedAccountGuids.length
      ? debtAccounts.filter((acc) => selectedAccountGuids.includes(acc.guid))
      : debtAccounts

    return loadDebts(filteredDebtAccounts, debtGoals)
  }

  get totalMonthlyPayments(): number {
    const payments = this.debts.map((d) => Number(d.monthly_payment)).filter((p) => !isNaN(p))
    return payments.reduce((total, payment) => total + payment, 0)
  }
}

export class UiStore {
  isLoading = false
  selectedDebtChartData: DebtChartData = {} as DebtChartData
  selectedDebtPriority: DebtPriority = DebtPriority.LOWEST_BALANCE

  constructor() {
    makeAutoObservable(this)
  }

  get showError() {
    const { interest_rate, monthly_payment } = this.selectedDebtChartData
    return interest_rate === undefined || monthly_payment === undefined
  }

  get showCompleted() {
    return this.selectedDebtChartData.is_paid_off
  }

  setIsLoading = (isLoading: boolean) => (this.isLoading = isLoading)

  setSelectedDebtChartData = (data: DebtChartData) => (this.selectedDebtChartData = data)

  setSelectedDebtPriority = (priority: DebtPriority) => (this.selectedDebtPriority = priority)
}
